import { format } from 'date-fns';

type PeriodTimeProps = {
  startsAt: string;
  endsAt: string;
  noBreakLine?: boolean;
}
export default function PeriodTime({ startsAt, endsAt, noBreakLine }: PeriodTimeProps) {
  const d1 = format(new Date(startsAt), 'dd/MM/yyyy');
  const d2 = format(new Date(endsAt), 'dd/MM/yyyy');

  if (noBreakLine)
    return (
      <>
        {d1} até {d2}
      </>
    );
  return (
    <>
      {d1}<br />
      {d2}
    </>
  );
}
